import { create } from 'zustand';

const DEFAULT_PERMISSIONS = {
  transactions:    true,
  fines:           true,
  changiwa:        true,
  monthly_report:  true,
  distribution:    true,
  dissolve_at_end: true,
};

const usePermissionsStore = create((set) => ({
  permissions: DEFAULT_PERMISSIONS,
  setPermissions: (perms) => set({ permissions: { ...DEFAULT_PERMISSIONS, ...perms } }),
  reset: () => set({ permissions: DEFAULT_PERMISSIONS }),
}));

export default usePermissionsStore;
